import React, {   useState } from 'react'
import {  Form, Input, App,Modal } from 'antd'
import { useChanpinTypeAddMutation } from '../../../store/DianShangYeWuApi';
import Icon from '../../../cpn/Icon';
function GoodsAdd(props) {
    const [open,setOpen] = useState(false)
    const{message} = App.useApp();    
    const [form] = Form.useForm(); 
    const [submit] = useChanpinTypeAddMutation();
    const [info,setInfo] = useState({
        dscp_name: '',
        dscp_qy_id: props.qy_id,
        dscp_qy_name: props.qy_name,
        dscp_uid: props.yh_id,
        dscp_uname: props.yh_name,
    })
    
 
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open}
                title='新增产品'
                width={800}
                onCancel={() => {setOpen(false)}} 
                onOk={() => {                    
                    submit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功')   
                            form.resetFields();  
                            setOpen(false);
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败：'+res.data.Message)
                        }
                    }) 
                }}            
            >
                <Form                                
                    form={form}
                    style={{width: '100%' }}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{
                        modifier: 'public',
                    }}
                    labelCol={{ span: 5}}                                 
                >   
                    <Form.Item name="dscp_name" wrapperCol={{span:10}} required label='产品名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,dscp_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                </Form>
            </Modal>
        </>
    )
}

export default GoodsAdd